import { TrimbleCoords } from './TrimbleCoords';

export class RouteResponse {
  geoTunnelPoints: TrimbleCoords[] = [];

  constructor(opts?: Partial<RouteResponse>) {
    if (opts?.geoTunnelPoints) {
      this.geoTunnelPoints = opts.geoTunnelPoints;
    }
  }
}
